<template>
  <div v-if="reportDetailModel" class="single-blood-oxygen-report" ref="imageDom">
    <!-- 屏幕显示的头部信息 -->
    <div class="screen-header">
      <img class="single-blood-oxygen-report-logo" :src="reportDetailModel.sopReportLogo"
        :style="{ width: reportDetailModel.xyReportTemplateType === 3 ? '166px' : '66px' }"
        v-if="reportDetailModel.sopReportLogo != null && reportDetailModel.sopReportLogo != ''">
        
      <p class="single-blood-oxygen-report-title">{{ reportDetailModel.sopReportHeaders || "" }}</p>
      <p class="single-blood-oxygen-report-subtitle">{{ reportDetailModel.sopReportSubTitle || "" }}</p>
      <div class="single-blood-oxygen-report-button-container" :class="useClassWithDifferentBrower()">
        <button class="single-blood-oxygen-report-button-container-item noPrint" @click="onShare">分享</button>
        <button class="single-blood-oxygen-report-button-container-item noPrint" @click="onDownloadPNG">下载PNG</button>
        <button class="single-blood-oxygen-report-button-container-item noPrint" @click="onDownloadPDF">下载PDF</button>
        <button class="single-blood-oxygen-report-button-container-item noPrint" @click="onPrint">打印</button>
      </div>
      <section-time :reportDetailModel="reportDetailModel" v-if="showBasicInfo"></section-time>
      <section-user-info :reportDetailModel="reportDetailModel" @onEditUserInfoSucceed="onEditUserInfoSucceed" v-if="showBasicInfo"></section-user-info>
    </div>

    <!-- 第一页内容包装器 -->
    <div class="print-page-1" :class="{ 'need-page-break': showSecondPage }" v-if="showFirstPage">
      <div class="print-header-for-page">
        <section-report-header-print 
          :reportDetailModel="reportDetailModel" 
          :pageSpecificSubtitle="reportDetailModel.printFirstPageTitle">
        </section-report-header-print>
      </div>
     
      <section-blood-oxygen 
        class="first-content-section" 
        :reportDetailModel="reportDetailModel"
        v-if="reportDetailModel.spo2PulseModuleConfig.includes('血氧统计')"
      ></section-blood-oxygen>
      <section-oxygen-minus-table v-if="reportDetailModel.spo2PulseModuleConfig.includes('氧减统计')" :reportDetailModel="reportDetailModel"></section-oxygen-minus-table>
      <section-trend-chart-template1  
      v-if="reportDetailModel.spo2PulseModuleConfig.includes('血氧趋势') && reportDetailModel.xyReportTemplateType !== 3"
      :reportDetailModel="reportDetailModel"></section-trend-chart-template1>
      <section-pulse 
      v-if="reportDetailModel.spo2PulseModuleConfig.includes('脉率统计')"
      :reportDetailModel="reportDetailModel"></section-pulse>
      <section-pulse-trend-chart 
      v-if="reportDetailModel.spo2PulseModuleConfig.includes('脉率趋势图') && reportDetailModel.xyReportTemplateType !== 3"
       :reportDetailModel="reportDetailModel"></section-pulse-trend-chart>
      <section-oxgen-monitoring-overview 
      v-if="reportDetailModel.spo2PulseModuleConfig.includes('血氧监测综述')"
       :reportDetailModel="reportDetailModel" @onEditSuggestionSucceed="onEditSuggestionSucceed"></section-oxgen-monitoring-overview>
      
      <!-- 第一页页码 -->
      <div class="page-number">第1页 共{{ totalPages }}页</div>
    </div>

    <!-- 第二页内容包装器 -->
    <div class="print-page-2" :class="{ 'need-page-break': showThirdPage }" v-if="showSecondPage">
      <div class="print-header-for-page">
        <section-report-header-print 
          :reportDetailModel="reportDetailModel" 
          :pageSpecificSubtitle="reportDetailModel.printSecondPageTitle">
        </section-report-header-print>
      </div>
     
      <!-- 睡眠分析 -->
      <div class="sleep-analysis-title" v-if="hasSleepAnalysisContent">睡眠分析</div>
      <div class="single-blood-oxygen-report-section sleep-content-section" v-if="reportDetailModel.sleepStructureModuleConfig.includes('睡眠时长概况')">
        <section-period-table :reportDetailModel="reportDetailModel"></section-period-table>
        <div class="single-blood-oxygen-report-section-chart">
          <section-period-chart :reportDetailModel="reportDetailModel"></section-period-chart>
          <section-time-period-chart :reportDetailModel="reportDetailModel"></section-time-period-chart>
        </div>
      </div>
      <section-trend-sleep-chart :reportDetailModel="reportDetailModel" v-if="reportDetailModel.sleepStructureModuleConfig.includes('睡眠分期图')"></section-trend-sleep-chart>
      <section-sleep-monitoring-overview 
        v-if="reportDetailModel.sleepStructureModuleConfig.includes('睡眠监测综述')"
       :reportDetailModel="reportDetailModel" @onEditSuggestionSucceed="onEditSuggestionSucceed"></section-sleep-monitoring-overview>
     
      <div class="hrv-analysis-title" v-if="hasHrvContent">心率分析</div>
       <section-hrv
         v-if="reportDetailModel.sleepStructureModuleConfig.includes('心率统计') && reportDetailModel.hrvData"
        :reportDetailModel="reportDetailModel">
       
      </section-hrv>
      <div class="hrv-section-row"  v-if="reportDetailModel.sleepStructureModuleConfig.includes('HRV') && reportDetailModel.hrvData">
        <section-hrv-field :reportDetailModel="reportDetailModel"></section-hrv-field>
        <section-rr-scatter :reportDetailModel="reportDetailModel"></section-rr-scatter>
      </div>
      
      <!-- 当没有HRV内容时，建议部分显示在第二页 -->
      <div class="suggestion-section" v-if="suggestionInSecondPage">
        <section-suggestion 
         :reportDetailModel="reportDetailModel" @onEditSuggestionSucceed="onEditSuggestionSucceed"></section-suggestion>
      </div>
      
      <!-- 第二页页码 -->
      <div class="page-number page-number-bottom">第2页 共{{ totalPages }}页</div>
    </div>

    <!-- 第三页内容包装器 -->
    <div class="print-page-3" v-if="showThirdPage">
      <div class="print-header-for-page">
        <section-report-header-print 
          :reportDetailModel="reportDetailModel" 
          :pageSpecificSubtitle="reportDetailModel.printThirdPageTitle || reportDetailModel.printSecondPageTitle">
        </section-report-header-print>
      </div>
      
      <div class="hrv-section-row hrv-charts-row"  v-if="reportDetailModel.sleepStructureModuleConfig.includes('HRV') && reportDetailModel.hrvData">
        <section-rr-distribution :reportDetailModel="reportDetailModel"></section-rr-distribution>
        <section-rr-frequency :reportDetailModel="reportDetailModel"></section-rr-frequency>
      </div>
      
      <!-- 当有HRV内容时，建议部分显示在第三页 -->
      <div class="suggestion-section">
        <section-suggestion 
         v-if="reportDetailModel.sleepStructureModuleConfig.includes('监测意见与建议')"
         :reportDetailModel="reportDetailModel" @onEditSuggestionSucceed="onEditSuggestionSucceed"></section-suggestion>
      </div>
      
      <!-- 第三页页码 -->
      <div class="page-number">第3页 共{{ totalPages }}页</div>
    </div>
    <!-- 报告底部 -->
    <section-report-bottom v-if="reportDetailModel.isShowIntended()"></section-report-bottom>
  </div>
</template>

<script>
import KeyValueUnit from "@c/report-detail/single-blood-oxygen-report/common/new-key-value-unit/key-value-unit-blood-oxygen-report.vue";
import SectionTime from "@c/report-detail/single-blood-oxygen-report/new-section/section-time.vue";
import SectionUserInfo from "@c/report-detail/single-blood-oxygen-report/new-section/section-user-info.vue";
import SectionReportHeaderPrint from "@c/report-detail/single-blood-oxygen-report/new-section/section-report-header-print.vue";
import SectionBloodOxygen from "@c/report-detail/single-blood-oxygen-report/new-section/section-blood-oxygen.vue";
import SectionOxygenMinusTable from "@c/report-detail/single-blood-oxygen-report/new-section/section-oxygen-minus-table.vue";
import SectionPulse from "@c/report-detail/single-blood-oxygen-report/new-section/section-pulse.vue";
import SectionHrv from "@c/report-detail/single-blood-oxygen-report/new-section/section-hrv.vue";
import SectionHrvField from "@c/report-detail/single-blood-oxygen-report/new-section/section-hrv-field.vue";
import SectionRRScatter from "@c/report-detail/single-blood-oxygen-report/new-section/section-rr-scatter.vue";
import SectionRRDistribution from "@c/report-detail/single-blood-oxygen-report/new-section/section-rr-distribution.vue";
import SectionRRFrequency from "@c/report-detail/single-blood-oxygen-report/new-section/section-rr-frequency.vue";
import SectionPeriod from "@c/report-detail/single-blood-oxygen-report/section-period.vue";
import SectionTrendChart from "@c/report-detail/single-blood-oxygen-report/section-trend-chart.vue";
import SectionTrendChartTemplate1 from "@c/report-detail/single-blood-oxygen-report/new-section/section-trend-chart-template1.vue";
import SectionBloodOxygenTable from "@c/report-detail/single-blood-oxygen-report/section-blood-oxygen-table.vue";
import SectionBloodOxygenChart from "@c/report-detail/single-blood-oxygen-report/section-blood-oxygen-chart.vue";
import SectionOxygenMinusEventTable from "@c/report-detail/single-blood-oxygen-report/section-oxygen-minus-event-table.vue";
import SectionOxygenMinusEventChart from "@c/report-detail/single-blood-oxygen-report/section-oxygen-minus-event-chart.vue";
import SectionOxygenMinusTimeTable from "@c/report-detail/single-blood-oxygen-report/section-oxygen-minus-time-table.vue";
import SectionOxygenMinusTimeChart from "@c/report-detail/single-blood-oxygen-report/section-oxygen-minus-time-chart.vue";
import SectionPeriodTable from "@c/report-detail/single-blood-oxygen-report/new-section/section-period-table.vue";
import SectionPeriodChart from "@c/report-detail/single-blood-oxygen-report/new-section/section-period-chart.vue";
import SectionTimePeriodChart from "@c/report-detail/single-blood-oxygen-report/new-section/section-time-period-chart.vue";
import SectionSuggestion from "@c/report-detail/single-blood-oxygen-report/new-section/section-suggestion.vue";
import SectionOxgenMonitoringOverview from "@c/report-detail/single-blood-oxygen-report/new-section/section-oxgen-monitoring-overview.vue";
import SectionSleepMonitoringOverview from "@c/report-detail/single-blood-oxygen-report/new-section/section-sleep-monitoring-overview.vue";
import SectionTrendSleepChart from "@c/report-detail/single-blood-oxygen-report/new-section/section-trend-sleep-chart.vue";
import SectionPulseTrendChart from "@c/report-detail/single-blood-oxygen-report/new-section/section-pulse-trend-chart.vue";
import SectionReportBottom from "@c/report-detail/single-blood-oxygen-report/section-report-bottom.vue";
import { ReportDetailModel } from "@c/report-detail/single-blood-oxygen-report/report-detail-model.js";
import { ReportPreviewTool } from "@js/report-preview-tool.js";
import html2canvas from "html2canvas";
import { DateTool } from "@js/date-tool.js";
import deviceTool from "@js/deviceTool.js";
import appHandler from "@js/appHandler.js"
import { MessageBox } from 'element-ui';

export default {
  components: {
    KeyValueUnit,
    SectionTime,
    SectionUserInfo,
    SectionBloodOxygen,
    SectionOxygenMinusTable,
    SectionHrv,
    SectionPulse,
    SectionPeriod,
    SectionTrendChart,
    SectionTrendChartTemplate1,
    SectionBloodOxygenTable,
    SectionBloodOxygenChart,
    SectionOxygenMinusEventTable,
    SectionOxygenMinusEventChart,
    SectionOxygenMinusTimeTable,
    SectionOxygenMinusTimeChart,
    SectionPeriodTable,
    SectionPeriodChart,
    SectionSuggestion,
    SectionReportBottom,
    SectionOxgenMonitoringOverview,
    SectionTimePeriodChart,
    SectionTrendSleepChart,
    SectionPulseTrendChart,
    SectionSleepMonitoringOverview,
    SectionReportHeaderPrint,
    SectionHrvField,
    SectionRrScatter: SectionRRScatter,
    SectionRrDistribution:SectionRRDistribution,
    SectionRrFrequency:SectionRRFrequency,
  },

  data() {
    return {
      enterInfo: undefined,
      reportDetailModel: undefined,
      uid: undefined
    };
  },

  computed: {
    
    // 判断是否显示第一页（血氧相关内容）
    showFirstPage() {
      if (!this.reportDetailModel?.spo2PulseModuleConfig) return false;
      
      return this.reportDetailModel.spo2PulseModuleConfig.includes('血氧统计') || 
             this.reportDetailModel.spo2PulseModuleConfig.includes('氧减统计') ||
             this.reportDetailModel.spo2PulseModuleConfig.includes('血氧趋势') ||
             this.reportDetailModel.spo2PulseModuleConfig.includes('脉率统计') ||
             this.reportDetailModel.spo2PulseModuleConfig.includes('脉率趋势图') ||
             this.reportDetailModel.spo2PulseModuleConfig.includes('血氧监测综述');
    },
    
    // 判断是否显示基本信息模块（时间和用户信息）
    showBasicInfo() {
      const spo2HasBasicInfo = this.reportDetailModel?.spo2PulseModuleConfig?.includes('基本信息');
      const sleepHasBasicInfo = this.reportDetailModel?.sleepStructureModuleConfig?.includes('基本信息');
      
      return spo2HasBasicInfo || sleepHasBasicInfo;
    },
    
    // 判断是否显示第二页（睡眠相关内容）
    showSecondPage() {
      if (!this.reportDetailModel?.sleepStructureModuleConfig) return false;
      
      return this.reportDetailModel.sleepStructureModuleConfig.includes('睡眠时长概况') || 
             this.reportDetailModel.sleepStructureModuleConfig.includes('睡眠分期图') ||
             this.reportDetailModel.sleepStructureModuleConfig.includes('睡眠监测综述') ||
             this.reportDetailModel.sleepStructureModuleConfig.includes('监测意见与建议');
    },
    
    // 判断是否显示第三页（RR分布和频谱图）
    showThirdPage() {
      // 只有当有HRV相关内容时才显示第三页
      return this.showSecondPage && this.hasHrvContent;
    },
    
    // 判断是否有HRV相关内容
    hasHrvContent() {
      if (!this.reportDetailModel?.sleepStructureModuleConfig) return false;
      if (!this.reportDetailModel?.hrvData) return false;
      
      // 只有当包含"HRV"模块时才认为有HRV内容，"心率统计"不算HRV内容
      return this.reportDetailModel.sleepStructureModuleConfig.includes('HRV');
    },
    
    // 判断建议部分应该在哪一页显示
    suggestionInSecondPage() {
      // 当没有HRV内容时，建议部分显示在第二页
      return !this.hasHrvContent && this.reportDetailModel?.sleepStructureModuleConfig?.includes('监测意见与建议');
    },
    
    // 判断是否有睡眠分析相关内容
    hasSleepAnalysisContent() {
      if (!this.reportDetailModel?.sleepStructureModuleConfig) return false;
      
      return this.reportDetailModel.sleepStructureModuleConfig.includes('睡眠时长概况') 
            
    },
    
    // 计算总页数
    totalPages() {
      let pages = 0;
      if (this.showFirstPage) pages++;
      if (this.showSecondPage) pages++;
      if (this.showThirdPage) pages++;
      return pages;
    }
  },

  async created() {
    this.enterInfo = this.$router.history.current.query;
    this.reportDetailModel = await this.getBloodOxygenReportDetail();
    console.log('reportDetailModel',this.reportDetailModel)
    console.log('睡眠分期统计',this.reportDetailModel.sleepStructureModuleConfig.includes('睡眠时长概况'))
  },

  methods: {
    onDownloadPNG() {
      let createMillisecondTimestamp = DateTool.strToMillisecondTimestamp(this.reportDetailModel.startTimeStr)
      let createTimeStr = DateTool.millisecondTimestampToStr(createMillisecondTimestamp, "M月D日 h：m")
      html2canvas(this.$refs.imageDom, {
        useCORS: true, //是否尝试使用CORS从服务器加载图像
      }).then((canvas) => {
        var imgData = canvas.toDataURL("image/jpeg");
        //如果是Android，发送消息
        if (deviceTool.getDeviceType() === "Android") {
          appHandler.sendMsg({
            path: this.$router.history.current.path,
            origin: "DownloadPNG",
            data: {
              name: this.reportDetailModel.nameStr,
              createTime: createTimeStr,
              imgData: imgData
            }
          })
        } else {
          let nameStr = this.reportDetailModel.nameStr;
          //河南省儿童医院定制报告名 {住院号}{姓名}-睡眠初筛报告 
          if (this.reportDetailModel.xyReportTemplateType == SPO2_REPORT_TEMPLATE.河南省儿童医院耳鼻喉科) {
            nameStr = this.reportDetailModel.medicalRecordNumber
            createTimeStr = this.reportDetailModel.nameStr + '-睡眠初筛报告';
          }
          ReportPreviewTool.downloadImageData(
            nameStr,
            createTimeStr,
            imgData
          );
        }
      });
    },

    async onDownloadPDF() {
      try {
        let downloadURL = await this.getBloodOxygenReportDownloadURL()
        //如果是Android，发送消息
        if (deviceTool.getDeviceType() === "Android") {
          this.downloadPDFWithAndroid(downloadURL, "DownloadPDF")
        } else {
          this.downloadPDFWithNormal(downloadURL)
        }
      } catch (error) {
        this.$toast.showRed(error)
      }
    },

    async onPrint() {
      if (deviceTool.getDeviceType() === "Android") {
        try {
          let downloadURL = await this.getBloodOxygenReportDownloadURL()
          //如果是Android，发送消息
          this.downloadPDFWithAndroid(downloadURL, "Print")
        } catch (error) {
          this.$toast.showRed(error)
        }
      } else {
        window.print();
      }
    },
    /**
     * 分享
     */
    async onShare() {
      if (deviceTool.getDeviceType() === "Android") {
        try {
          let downloadURL = await this.getBloodOxygenReportDownloadURL()
          let createMillisecondTimestamp = DateTool.strToMillisecondTimestamp(this.reportDetailModel.startTimeStr)
          let createTimeStr = DateTool.millisecondTimestampToStr(createMillisecondTimestamp, "M月D日 h：m")
          //如果是Android，发送消息
          appHandler.sendMsg({
            path: this.$router.history.current.path,
            origin: "Share",
            data: {
              name: this.reportDetailModel.nameStr,
              createTime: createTimeStr,
              url: downloadURL
            }
          })
        } catch (error) {
          this.$toast.showRed(error)
        }
      } else {
        try {
          let downloadURL = await this.getBloodOxygenReportDownloadURL()
          let title = `【睡眠初筛报告${this.reportDetailModel?.startTimeStr || ''}${this.reportDetailModel.nameStr}】`
          MessageBox.alert(title + downloadURL, '分享内容', {
            confirmButtonText: '确定',
            callback: action => {
              this.$copyText(title + downloadURL)
              this.$toast.showGreen(MSG.copyToClipboardSuccess);
            }
          });
        } catch (error) {
          this.$toast.showRed(error)
        }
      }
      
    },

    async onEditSuggestionSucceed() {
      this.$toast.showGreen("编辑成功");
      this.reportDetailModel = await this.getBloodOxygenReportDetail();
    },

    onEditSummarizeSucceed(){
      alert('综述')

    },

    async onEditUserInfoSucceed() {
      this.$toast.showGreen("编辑成功");
      this.reportDetailModel = await this.getBloodOxygenReportDetail();
    },

    async getBloodOxygenReportDetail() {
      const params = {
        reportId: this.enterInfo.reportId,
      };
      try {
        const data = await this.$api.getBloodOxygenReportDetail(params)
        console.log('data:',data);
        
        const reportDetailModel = new ReportDetailModel(data)
        return reportDetailModel;
      } catch (error) {
        this.$toast.showRed(error)
      }
    },

    async getBloodOxygenReportDownloadURL() {
      const params = {
        reportId: this.enterInfo.reportId,
      };
      try {
        const downloadURL = await this.$api.getBloodOxygenReportDownloadURL(params)
        return downloadURL;
      } catch (error) {
        throw error
      }
    },
    useClassWithDifferentBrower() {
      //为了控制打印三页睡眠初筛报告，测试了五个浏览器FireFox，Chrome，Edge，Opera，Safari，只有Safari异常，所以添加这个方法调整css。
      const browserType = deviceTool.getBrowserType()
      if (browserType === 'Safari') {
        return 'single-blood-oxygen-report-button-container-Safari-no-print'
      } else {
        return ''
      }
    },
    downloadPDFWithAndroid(url, oringin) {
      let createMillisecondTimestamp = DateTool.strToMillisecondTimestamp(this.reportDetailModel.startTimeStr)
      let createTimeStr = DateTool.millisecondTimestampToStr(createMillisecondTimestamp, "M月D日 h：m")
      appHandler.sendMsg({
        path: this.$router.history.current.path,
        origin: oringin,
        data: {
          name: this.reportDetailModel.nameStr,
          createTime: createTimeStr,
          url: url
        }
      })
    },
    downloadPDFWithNormal(url) {
      ReportPreviewTool.downloadBloodOxygenReport(url);
    }

  },
};
</script>

<style lang="scss" scoped>
.single-blood-oxygen-report {
  width: 1050px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 20px 40px 10px;
  
  .single-blood-oxygen-report-section-chart{
    display: flex;
    justify-content: space-between;
    // flex-direction: column;
  }

  .hrv-section-row {
    display: flex;
    gap: 10px;
    width: 100%;
    margin: 0;
    
    > * {
      flex: 1;
      min-width: 0; // 允许子元素收缩
      max-width: 50%; // 限制最大宽度
    }
    
    // 第三页的HRV图表行需要额外的底部间距
    &.hrv-charts-row {
      margin-bottom: 30px;
    }
  }

  &-logo {
    height: 66px;
    width: 66px;
    position: absolute;
  }

  &-title {
    color: black;
    font-size: 24px;
    font-weight: 600;
    height: 24px;
    display: flex;
    justify-content: center;
  }

  &-subtitle {
    color: black;
    font-size: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    margin-top: 5px;
  }

  &-button-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 44px;
    margin-bottom: 30px;

    &-item {
      color: white;
      background-color: #325FAC;
      border-radius: 4px;
      width: 88px;
      height: 32px;
      margin-left: 20px;
    }
  }

  &-section-title {
    color: black;
    font-size: 24px;
    font-weight: 600;
    line-height: 73px;
    width: 100%;
  }

  &-section {
    display: flex;
  }

  // 新的、针对每页的打印页眉的容器 - 默认隐藏，打印时显示
  .print-header-for-page {
    display: none; // 默认在屏幕上隐藏
    padding-bottom: 20px; // 给页眉和下方内容留出一些间距
  }

  // 屏幕显示的头部信息 - 默认显示
  .screen-header {
    display: block;
  }

  // 页码样式 - 屏幕上隐藏
  .page-number {
    display: none;
    text-align: center;
    font-size: 12px;
    color: #666;
    margin-top: 20px;
    // margin-bottom: 10px;
  }

  // 第三页的建议部分
  .suggestion-section {
    width: 100%;
    margin-top: 20px;
  }
  
  // 心率分析大标题样式
  .hrv-analysis-title {
    color: black;
    font-size: 24px;
    font-weight: 600;
    line-height: 73px;
    width: 100%;
    
  }
  
  // 睡眠分析大标题样式
  .sleep-analysis-title {
    color: black;
    font-size: 24px;
    font-weight: 600;
    line-height: 73px;
    width: 100%;
   
  }
}

@media print {
  @page {
    size: A4;
    margin: 10mm;
  }
  
  .single-blood-oxygen-report {
    width: 100% !important;
    max-width: none !important;
    padding: 0 !important; // 打印时移除父容器的padding，由页眉和内容自行控制
    
    // 新的、针对每页的打印页眉的容器 - 打印时显示
    .print-header-for-page {
      display: block !important;
    }

    .screen-header {
      display: none !important;
    }

    .print-page-1 {
      // margin-top: 200px !important; // 移除，因为页眉现在在流内
      min-height: auto !important; // 或者根据内容调整
      padding-top: 5mm; // 顶部留出页边距的空间
      display: flex !important;
      flex-direction: column !important;
      min-height: calc(100vh - 20mm) !important; // 设置最小高度，减去上下边距
      
      // 只有当需要分页时才设置分页
      &.need-page-break {
        page-break-after: always !important;
        break-after: page !important;
      }
    }
    
    .print-page-2 {
      // margin-top: 220px !important; // 移除，因为页眉现在在流内
      width: 100% !important;
      box-sizing: border-box !important;
      padding-top: 5mm; // 顶部留出页边距的空间
      display: flex !important;
      flex-direction: column !important;
      min-height: calc(100vh - 10mm) !important; // 设置最小高度，减去上下边距
      position: relative !important; // 为绝对定位的页码提供参考
      padding-bottom: 20mm !important; // 为页码留出更多空间
      
      // 只有当需要分页时才设置分页
      &.need-page-break {
        page-break-after: always !important;
        break-after: page !important;
      }
    }
    
    .print-page-3 {
      width: 100% !important;
      box-sizing: border-box !important;
      padding-top: 5mm; // 顶部留出页边距的空间
      display: flex !important;
      flex-direction: column !important;
      min-height: calc(100vh) !important; // 设置最小高度，减去上下边距
    }
    
    .first-content-section {
      margin-top: 0 !important;
    }
    
    .sleep-content-section {
      margin-top: 0 !important;
      width: 100% !important;
    }
    
    // 关键：调整图表容器
    .single-blood-oxygen-report-section-chart {
      display: flex !important;
      justify-content: space-between !important;
      width: 100% !important;
      box-sizing: border-box !important;
      gap: 5px !important; // 减少间距
      
      > * {
        flex: 1 !important;
        max-width: 49% !important; // 增加宽度
        min-width: 0 !important; // 允许收缩
      }
    }
    
    // HRV 行布局
    .hrv-section-row {
      display: flex !important;
      gap: 5px !important;
      width: 100% !important;
      box-sizing: border-box !important;
      margin: 0 !important;
      
      > * {
        flex: 1 !important;
        min-width: 0 !important;
        max-width: 48% !important;
      }
      
      // 第三页的HRV图表行需要额外的底部间距
      &.hrv-charts-row {
        margin-bottom: 100px !important;
      }
    }
    
    // 第三页的建议部分
    .suggestion-section {
      width: 100% !important;
      margin-top: 30px !important;
      page-break-inside: avoid !important; // 避免建议部分被分页
    }
    
    // 心率分析大标题打印样式
    .hrv-analysis-title {
      font-size: 20px !important;
      line-height: 43px !important;
      color: black;
      font-weight: 600;
      width: 100%;
    }
    
    // 睡眠分析大标题打印样式
    .sleep-analysis-title {
      font-size: 20px !important;
      line-height: 43px !important;
      color: black;
      font-weight: 600;
      width: 100%;
    }

    // 页码在打印时显示
    .page-number {
      display: block !important;
      text-align: center !important;
      font-size: 12px !important;
      color: #333 !important;
      position: relative !important;
      margin-top: auto !important;
      // margin-bottom: 5mm !important;
      width: 100% !important;
      page-break-inside: avoid !important;
      page-break-before: avoid !important;
      
      // 第二页页码特殊样式 - 固定在底部
      &.page-number-bottom {
        position: absolute !important;
        bottom: 1mm !important;
        left: 0 !important;
        right: 0 !important;
        margin-top: 0 !important;
      }
    }
  }

  // 将深度选择器提到外层
  ::v-deep .sleep-pie-chart {
    width: 100% !important;
    min-width: 260px !important;
    height: 220px !important;
  }

  .single-blood-oxygen-report-button-container-Safari-no-print {
    height: 40px;
    margin: 0px;
  }

  .noPrint {
    background-color: white !important;
  }
}
</style>